<template>
    <main class="contact">
        <div class="page-header">
            <h1 class="page-header__title">Kontakt</h1>
        </div>
        <form class="contact__wrapper" @submit="handleSubmit">
            <h1 class="contact__title">Formularz kontaktowy</h1>
            <div class="form__error" v-if="error">{{ error }}</div>
            <div class="form__success" v-if="success">{{ success }}</div>
            <div class="form__row" v-if="!isAuthenticated">
                <div class="form__col">
                    <input
                        type="text"
                        v-model="form.firstName"
                        placeholder="Imię*"
                        :required="!isAuthenticated"
                    />
                </div>
                <div class="form__col">
                    <input
                        type="text"
                        v-model="form.email"
                        placeholder="Adres e-mail*"
                        :required="!isAuthenticated"
                    />
                </div>
            </div>
            <div class="contact__center">
        <textarea
            class="contact__field"
            v-model="form.message"
            placeholder="Wpisz tutaj wiadomość..."
            rows="4"
        ></textarea>
                <button class="btn btn__contact">Wyślij</button>
            </div>
            <div class="contact__row contact-actions">
                <div class="contact-actions__item">
                    <div class="contact-actions__link">
                        <img src="@/assets/svg/envelope.svg" class="contact__icon" alt="E-mail"/>kontakt@racer-online.pl
                    </div>
                </div>
                <div class="contact-actions__item">
                    <div class="contact-actions__link">
                        <img src="@/assets/svg/phone.svg" class="contact__icon" alt="Phone"/>+48 884 700 069
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";

export default {
    name: "Comments",
    data() {
        return {
            error: "",
            success: "",
            form: {
                message: "",
                firstName: "",
                email: ""
            }
        };
    },
    computed: mapGetters({
        isAuthenticated: "isAuthenticated",
        token: "getToken"
    }),
    methods: {
        handleSubmit(e) {
            e.preventDefault();

            this.error = "";

            if (!this.isAuthenticated && (!this.form.firstName || !this.form.email)) {
                this.error = "Musisz podać imię oraz adres e-mail";
            }

            if (this.form.message && !this.error) {
                if (this.isAuthenticated) {
                    axios({
                        method: "post",
                        url: `${process.env.VUE_APP_API_URL}/contact`,
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${this.token}`
                        },
                        data: {
                            message: this.form.message
                        }
                    }).then(() => {
                        this.success = "Wiadomość została wysłana";
                        this.$store.dispatch('refreshUserToken')
                    }).catch(error => {
                        this.error = `Wystąpił błąd: ${error}`
                    });
                } else {
                    axios({
                        method: "post",
                        url: `${process.env.VUE_APP_API_URL}/public/contact`,
                        headers: {
                            "Content-type": "application/json"
                        },
                        data: {
                            message: this.form.message,
                            firstName: this.form.firstName,
                            email: this.form.email
                        }
                    }).then(() => {
                        this.success = "Wiadomość została wysłana";
                    }).catch(error => {
                        this.error = `Wystąpił błąd: ${error}`
                    });
                }
            } else {
                this.error = "Musisz wpisać wiadomość";
            }
        }
    }
};
</script>

<style lang="scss">
.contact {
    flex: 1;

    &__wrapper {
        width: 95%;
        max-width: 750px;
        margin: 30px auto;

        .form__error,
        .form__success {
            margin: 15px 0;
        }
    }

    &__title {
        font-size: 18px;
    }

    &__center {
        text-align: center;
    }

    &-actions {
        text-align: center;
        font-size: 18px;
        margin-top: 30px;
        flex-wrap: nowrap;

        &__item {
            @include media-breakpoint-up(md) {
                flex: 1;
            }
        }

        &__link {
            font-weight: bold;
            color: #505050;
        }
    }

    &__row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        margin: 12px 0;
        position: relative;
    }

    &__icon {
        height: 21px;
        width: 21px;
        vertical-align: middle;
        margin: 0 10px 0 0;
    }

    &__field {
        width: 100%;
        border-radius: 22px;
        padding: 12px;
        border: 2px solid #e1e1e1;
        box-sizing: border-box;

        &:focus {
            outline: none;
            border-color: #85b904;
        }
    }
}

.btn__contact {
    margin: 20px;
}

.form__col {
    flex: 0 0 50%;
    max-width: 55.5555%;
}
</style>
